import { NavLink, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

const homeUrl = process.env.REACT_APP_HOME_URL;
const adminUrl = process.env.REACT_APP_ADMIN_URL;

const BlogDetails = () => {
  const { blog_slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [blog, setBlog] = useState([]);
  const [blogs, setBlogs] = useState([]);
  useEffect(() => {
    const fetchBlog = async () => {
      try {

      	const blogUrl = `${adminUrl}/api/blogs/${blog_slug}`;
        const response = await fetch(blogUrl);
        const data = await response.json();    
        setBlog(data);
      } catch (err) {
        console.error('Error fetching RSS feed:', err);
      }
    };

    fetchBlog();
  }, []);

  useEffect(() => {
	const fetchBlogs = async () => {
		try {
			const response = await fetch(`${adminUrl}/api/blogs`);
			const data = await response.json();    
			setBlogs(data.data);
			setLoading(false);
		} catch (err) {
			setLoading(false);
			console.error('Error fetching RSS feed:', err);
		}
	};

	fetchBlogs();
}, []);


  const formatDate = (dateString) => {
	const date = new Date(dateString);
	return date.toLocaleString('en-US', {
	year: 'numeric',
	month: 'long',
	day: 'numeric',
	hour: 'numeric',
	minute: '2-digit',
	hour12: true
	});
  };
return (

<div className="articaldetails_wrapper blog_details_wrapper">
	<div className="articaldetails_mainsec">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-7 col-lg-8 col-xl-8">
					<div className="detailspage_contnt">
						<div className="breadcrumb_mainsec">
							<ul>
								<li><a href="#">Home</a></li>
								<li><span>{blog.title}</span></li>
							</ul>
						</div>

						<div className="categorybox">
							<div className="categorytxt">
								
							</div>
						</div>
						
						<div className="imgbox">
							<img src={`${adminUrl}/public/storage/${blog.image}`} alt={blog.title} />
						</div>
						
						<div className="author_info">
							
							<div className="iconbox">
								<i className="far fa-calendar"></i>
								<span>{formatDate(blog.created_at)}</span>
							</div>
						</div>
						
						<div className="contnt_box">
							<h2>{blog.title}</h2>
							<div dangerouslySetInnerHTML={{ __html: blog.content }} />
						</div>
						
						<div className="share_social_sec">
							<span className="titletxt">Share:</span>
							<ul>
								<li>
									<a
										  href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${homeUrl}blog/${blog.slug}`)}`}
										  target="_blank"
										  rel="noopener noreferrer"
										><i className="fab fa-facebook-f"></i>
									</a>
								</li>
								<li>
									<a
									  href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(`${homeUrl}blog/${blog.slug}`)}`}
									  target="_blank"
									  rel="noopener noreferrer"
									><i className="fab fa-linkedin-in"></i>
									</a>
								</li>
								<li>
									<a
									  href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(`${homeUrl}blog/${blog.slug}`)}&text=${encodeURIComponent(blog.title)}`}
									  target="_blank"
									  rel="noopener noreferrer"
									><i className="fab fa-twitter"></i>
									</a>
								</li>
								<li>
									<a
									  href={`https://t.me/share/url?url=${encodeURIComponent(`${homeUrl}blog/${blog.slug}`)}&text=${encodeURIComponent(blog.title)}`}
									  target="_blank"
									  rel="noopener noreferrer"
									><i class="fab fa-telegram-plane"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
					
				</div>
				
				<div className="col-sm-12 col-md-5 col-lg-4 col-xl-4">
					<div className="artical_sidebar">
					
						<div className="latest_newsbox">
							<div className="title_box">
								<h2>Latest News</h2>
							</div>
							
							<div className="articals_sec">
								{blogs.slice(0, 5).map((item, index) => (							
								<div className="articals_mainbox">
									<div className="articals_imgbox">
										<img src={`${adminUrl}/public/storage/${item.image}`} alt={item.title} />
									</div>
									
									<div className="articals_contntbox">
										<div className="artical_contnt">
											<h3><a href={`${homeUrl}blog/${item.slug}`}>{item.title}</a></h3>
										</div>
										
										<div className="artical_info">
											<span className="time_txt">{formatDate(item.created_at)}</span>
										</div>
									</div>
								</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
		{loading && (
			<div className="loader_mainbox">
				<div className="loader_mainsec">
					<div className="loader market-spinner">
						<svg class="icon" viewBox="0 0 24 24" width="20" height="20" aria-label="Loading market data">
						<polyline points="22 7 13.5 15.5 8.5 10.5 2 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						<polyline points="16 7 22 7 22 13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</div>
						 
					<div className="text-loader">
						<span>C</span>
						<span>O</span>
						<span>I</span>
						<span>N</span>
						<span>V</span>
						<span>I</span>
						<span>E</span>
						<span>W</span>
						<span>S</span>
					</div>
				</div>
			</div>
		)}
</div>

);
};

export default BlogDetails;